import BookModal from './BookModal';

export default BookModal;
